import revive_payload_client_4sVQNw7RlN from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import vuetify_i18n_H4uUvhyrU1 from "/home/vsts/work/1/s/client-app/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-i18n.js";
import vuetify_icons_KAumv2pUni from "/home/vsts/work/1/s/client-app/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-icons.js";
import unhead_KgADcZ0jPj from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_client_UciE0i6zes from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import cross_origin_prefetch_client_UzIc2qvBnC from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/app/plugins/cross-origin-prefetch.client.js";
import components_plugin_KR1HBZs4kY from "/home/vsts/work/1/s/client-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/vsts/work/1/s/client-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import vuetify_no_client_hints_kyYn5AnnAK from "/home/vsts/work/1/s/client-app/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-no-client-hints.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/vsts/work/1/s/client-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/home/vsts/work/1/s/client-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import vuetify_F4zXYcNIwC from "/home/vsts/work/1/s/client-app/src/plugins/vuetify.ts";
import leaflet_client_4l5ttfUccU from "/home/vsts/work/1/s/client-app/src/plugins/leaflet.client.ts";
import vuetify_nuxt_plugin_client_JOtFoHdxcp from "/home/vsts/work/1/s/client-app/.nuxt/vuetify-nuxt-plugin.client.mjs";
export default [
  revive_payload_client_4sVQNw7RlN,
  vuetify_i18n_H4uUvhyrU1,
  vuetify_icons_KAumv2pUni,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_client_UciE0i6zes,
  cross_origin_prefetch_client_UzIc2qvBnC,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  vuetify_no_client_hints_kyYn5AnnAK,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  vuetify_F4zXYcNIwC,
  leaflet_client_4l5ttfUccU,
  vuetify_nuxt_plugin_client_JOtFoHdxcp
]